import * as React from "react";
import { PageHeader } from "@ozpanel/kit";
import { PlaneMatrixPanel } from "./PlaneMatrix";

/**
 * The transfer watch as a standalone screen, so it has a route of its own and can be popped out.
 *
 * In popout mode the chrome is dropped: this window exists to be left open on a second display
 * through a failover, and a header that repeats what the panel already says costs rows of the only
 * thing being watched.
 */
export function PlaneMatrixScreen() {
  const popout = new URLSearchParams(window.location.search).get("popout") === "1" ||
    window.location.hash.includes("popout=1");

  React.useEffect(() => {
    if (popout) document.title = "ozpanel — role transfer";
  }, [popout]);

  if (popout) {
    return (
      <div style={{ padding: 16 }}>
        <PlaneMatrixPanel embedded />
      </div>
    );
  }
  return (
    <>
      <PageHeader
        title="Role transfer"
        subtitle="Every service plane on every node, and whether the move is actually finished"
      />
      <PlaneMatrixPanel />
    </>
  );
}
